import { defineMessages } from "react-intl";

export const translations = defineMessages({
  NoKpiDataMessage: {
    id: "KpiDataNotAvailable.DataNotAvailableMessage",
    defaultMessage: "There are no datas available for the current selection.",
  },
});
